define.alias("ember-math-helpers/helpers/hypot", "preview-grid/helpers/hypot");